import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { FormCambiarPassword } from "./FormCambiarPassword";

/**
 * La tarjeta de "cambiar contraseña" con su modal.
 *
 * Estaba copiada igual en los tres perfiles (vendedor, comprador y admin), cada
 * uno con su propio `show` en el estado. Es una sola cosa y vive en un solo
 * lugar.
 */
class PanelSeguridad extends React.Component {
  state = {
    show: false,
  };

  handleClose = () => this.setState({ show: false });

  render() {
    return (
      <>
        <h4>Contraseña de usuario</h4>
        <div className="dashboard__content-prod">
          <div className="dashboard__profile">
            <div className="dashboard__profile-icon">
              <div className="dashboard__profile-icon--password">
                <FontAwesomeIcon icon="fa-solid fa-asterisk" />
                <FontAwesomeIcon icon="fa-solid fa-asterisk" />
                <FontAwesomeIcon icon="fa-solid fa-asterisk" />
                <FontAwesomeIcon icon="fa-solid fa-asterisk" />
                <FontAwesomeIcon icon="fa-solid fa-asterisk" />
              </div>
              <span>Modificar contraseña</span>
            </div>
            <button
              className="button"
              data-type="complementary"
              type="button"
              onClick={() => this.setState({ show: true })}
            >
              Cambiar
            </button>
          </div>
        </div>

        {this.state.show && (
          <FormCambiarPassword
            show={this.state.show}
            handleClose={this.handleClose}
          />
        )}
      </>
    );
  }
}

export { PanelSeguridad };
